import { createSlice } from "@reduxjs/toolkit";

interface NotificationInitialStateModel {
  filter:any;
}
const NotificationInitialState: NotificationInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    SortProperty:"InsertDate",
    SortType:"asc"
  }
};

const notificationSlice = createSlice({
  name: "NotificationSlice ",
  initialState: NotificationInitialState,
  reducers: {
    handleSetNotificationFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetNotificationFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc"
      };
    },
   
   
    
  },
});

export const {
  handleSetNotificationFilter,
  handleResetNotificationFitler,
} = notificationSlice.actions;
export default notificationSlice;
